module.exports = function (event) {
   return {
       event: 'BWSAUcheckoutError',
       eventContext: {
           area: 'checkout',
           errorType: event.errorType,
           errorMessage: event.errorMessage
       }
   };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/checkout/components/checkoutwizard/atmmapper/checkout-error-mapper.js
 **/